// extracted by mini-css-extract-plugin
module.exports = {"userName":"UserInformationCard_userName__1sXs8","userInfo":"UserInformationCard_userInfo__2Q1Fj","bottomRight":"UserInformationCard_bottomRight__20oS8"};